<script type="text/javascript">
    import {post,get} from './request';
    import { Message, Loading } from 'element-ui';
    const CommImgHttp = "http://127.0.0.1:8081/";
    
    const CommEditor = {
            placeholder: "请在这里输入",
            modules:{
                toolbar:[
                      ['bold', 'italic', 'underline', 'strike'],    //加粗，斜体，下划线，删除线
                      ['blockquote', 'code-block'],     //引用，代码块
                      [{ 'header': 1 }, { 'header': 2 }],        // 标题，键值对的形式；1、2表示字体大小
                      [{ 'list': 'ordered'}, { 'list': 'bullet' }],     //列表
                      [{ 'script': 'sub'}, { 'script': 'super' }],   // 上下标
                      [{ 'indent': '-1'}, { 'indent': '+1' }],     // 缩进
                      [{ 'direction': 'rtl' }],             // 文本方向
                      [{ 'size': ['small', false, 'large', 'huge'] }], // 字体大小
                      [{ 'header': [1, 2, 3, 4, 5, 6, false] }],     //几级标题
                      [{ 'color': [] }, { 'background': [] }],     // 字体颜色，字体背景颜色
                      [{ 'font': [] }],     //字体
                      [{ 'align': [] }],    //对齐方式
                      ['clean'],    //清除字体样式
                      ['image','video']    //上传图片、上传视频
                      ]
            }
    }
    function isPhone(val) {
        var myreg=/^[1][3,4,5,7,8,9][0-9]{9}$/;
        if (!myreg.test(val)) {return false;} 
        else{return true;}
    };
    function isEmail(val) {
        var myreg=/^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/;
        if (!myreg.test(val)) {return false;} 
        else{return true;}
    };
    function isCard(val) {
        var myreg=/^[1-9]\d{5}(18|19|20|(3\d))\d{2}((0[1-9])|(1[0-2]))(([0-2][1-9])|10|20|30|31)\d{3}[0-9Xx]$/;
        if (!myreg.test(val)) {return false;} 
        else{return true;}
    };
    var FileUpData = (file, successCallback, errorCallback) => {
        // 确保传入的是 FormData 对象
        let formData = file instanceof FormData ? file : new FormData();
        
        // 如果传入的不是 FormData，则假定是文件对象，需要构建 FormData
        if (!(file instanceof FormData)) {
            formData.append('file', file);
        }

        post("/common/upload", formData)
            .then((res) => {
                if (res.data.code === 200) {
                    // 上传成功，返回处理后的文件信息
                    const fileInfo = {
                        name: res.data.originalFilename,
                        fileName: res.data.fileName,
                        newFileName: res.data.newFileName,
                        url: res.data.url,
                        status: 'success'
                    };
                    
                    if (successCallback && typeof successCallback === 'function') {
                        successCallback(fileInfo);
                    }
                    
                    Message({ message: '上传成功', type: 'success' });
                } else {
                    if (errorCallback && typeof errorCallback === 'function') {
                        errorCallback(res.data);
                    }
                    Message({ message: res.data.msg || '上传失败', type: 'error' });
                }
            })
            .catch(error => {
                if (errorCallback && typeof errorCallback === 'function') {
                    errorCallback(error);
                }
                Message({ message: '上传出错', type: 'error' });
            });
    };
    function _isMobile() {
    	 let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i)
    	 return flag;
    }
    function _isFileName(name) {
        let url = name.url?String(name.url):String(name);
    	const fileExtension = url.split('.').pop().toLowerCase();
        switch (fileExtension) {
            case 'jpg':
            case 'jpeg':
            case 'png':
              return CommImgHttp+url;
              break;
            case 'pdf':
              return CommImgHttp+'/img/pdf.png';
              break;
            case 'doc':
            case 'docx':
              return CommImgHttp+'/img/word.png';;
              break;
            case 'xls':
            case 'xlsx':
                return CommImgHttp+'/img/exel.png';;
                break;
            case 'zip':
            case 'rar':
                return CommImgHttp+'/img/ysb.png';
                break;
        }
    }
    function goTime(val) {
        var timestamp4 = new Date(val*1000);
        //利用拼接正则等手段转化为yyyy-MM-dd hh:mm:ss 格式
        return timestamp4.toLocaleDateString().replace(/\//g, "-") + " " + timestamp4.toTimeString().substr(0,8);
    }
    export default{
        CommImgHttp,
        CommEditor,
        isPhone,
        isEmail,
        isCard,
        FileUpData,
        _isMobile,
        _isFileName,
        goTime,
    }
</script>
